import { LocationData } from "./types";

// 获取用户位置
export const getUserLocation = (): Promise<LocationData> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by this browser."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location: LocationData = {
          latitude: position.coords.latitude.toString(),
          longitude: position.coords.longitude.toString(),
          accuracy: position.coords.accuracy?.toString() || "0",
        };
        resolve(location);
      },
      (error) => {
        console.error("Error getting location:", error);
        // 如果获取位置失败，返回默认位置
        const defaultLocation: LocationData = {
          latitude: "0",
          longitude: "0",
          accuracy: "0",
        };
        resolve(defaultLocation);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      }
    );
  });
};
